module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": "",
      "div": "",
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": "Home"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "300",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "v-fade-transition",
      "persistent": ""
    },
    model: {
      value: (_vm.loginDialogVisible),
      callback: function($$v) {
        _vm.loginDialogVisible = $$v
      },
      expression: "loginDialogVisible"
    }
  }, [_c('v-card', [_c('div', {
    staticStyle: {
      "height": "300px"
    }
  }, [_c('v-card-text', [(_vm.showLoginButton) ? _c('div', {
    staticClass: "center-text"
  }, [_c('div', {
    staticStyle: {
      "font-size": "1.2em",
      "padding-bottom": "10px"
    }
  }, [_vm._v("Sign In")]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Holy guacamole. You need to be signed in to access this page")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "120px",
      "margin-bottom": "10px"
    },
    attrs: {
      "src": "/static/images/taco.jpg"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.loginEnabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.signIn($event)
      }
    }
  }, [_vm._v("\n                Login with Google\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.showSigningIn) ? _c('div', {
    staticClass: "center-text",
    staticStyle: {
      "padding-top": "120px"
    }
  }, [_c('v-progress-circular', {
    staticClass: "primary--text",
    attrs: {
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n            Signing In...\n        ")], 1) : _vm._e()])], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "timeout": _vm.alert.timeout
    },
    on: {
      "click": _vm.clearAlert
    },
    model: {
      value: (_vm.alert.visible),
      callback: function($$v) {
        _vm.$set(_vm.alert, "visible", $$v)
      },
      expression: "alert.visible"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.alert.message) + "\n        "), (_vm.alert.button) ? _c('v-btn', {
    attrs: {
      "text": "",
      "dark": ""
    }
  }, [_vm._v("Got It")]) : _vm._e()], 1), _vm._v(" "), (_vm.isChatting) ? _c('ChatWindow') : _vm._e(), _vm._v(" "), _c('EmailIndicator', {
    ref: "emailIndicator"
  }), _vm._v(" "), _c('ConfirmDialog', {
    ref: "confirm"
  }), _vm._v(" "), _c('YouTubeDialog', {
    ref: "youtube"
  }), _vm._v(" "), _c('FormDialog', {
    ref: "formDialog"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40329951"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 2523
// module chunks = 1